import React from 'react';
import Currency from 'components/Currency';
import { Flex, Text } from '@qga/roo-ui/components';
import { AvaCurrency } from 'types/ava';

type Props = {
  charges: {
    total: AvaCurrency;
    totalCash?: AvaCurrency;
  };
};

const CashAndPointsPrices = ({ charges }: Props) => {
  const { total, totalCash } = charges;

  return (
    <Flex flexDirection="column" mt={1}>
      <Currency
        {...totalCash}
        testId="currency"
        color="greys.charcoal"
        currencySymbolProps={{
          fontSize: 'sm',
          marginBottom: '6px',
        }}
        fontSize={['lg', 'xl']}
        fontWeight="bold"
        roundToCeiling
        alignCurrency="left"
        data-testid="cash-item"
      />

      <Text as="div" color={['greys.steel', 'greys.charcoal']} fontSize={['sm', 'base']} lineHeight={[1.375, 1.5]} textAlign="end">
        or{' '}
        <Currency
          {...total}
          testId="total-points"
          color="greys.charcoal"
          alignCurrency="superscript"
          fontSize="sm"
          lineHeight="inherit"
          fontWeight="bold"
          roundToCeiling
          currencyTextFontSize="sm"
          currencyTextSuffix="*"
          data-testid="points-item"
        />
      </Text>
    </Flex>
  );
};

export default CashAndPointsPrices;
